import React, { FunctionComponent, Dispatch } from "react";
import { connect, ConnectedProps } from "react-redux";
import { signInWithGoogle } from "../../redux/actions/AuthActions";
import { Button } from "@material-ui/core";
import {
  authActionInterface,
  AuthInterface
} from "../../redux/reducers/AuthReducers";

interface actionsType {
  signInWithGoogle: () => (dispatch: Dispatch<authActionInterface>) => void;
}
interface RootState {
  auth: AuthInterface;
}

const actionsReducers: actionsType = { signInWithGoogle };

const mapStateToProps = (state: RootState) => ({
  auth: state.auth
});

const connector = connect(mapStateToProps, actionsReducers);

interface SessionRouterProps {}

type PropsFromRedux = ConnectedProps<typeof connector>;

const SessionRouter: FunctionComponent<SessionRouterProps &
  PropsFromRedux> = props => {
  function signInWithGoogle() {
    props.signInWithGoogle();
  }

  function renderComponent() {
    return (
      <Button variant="outlined" onClick={signInWithGoogle}>
        <div style={{ overflow: "hidden", marginRight: "5px" }}>
          <div className="logo"></div>
        </div>
        Sign In With Google
      </Button>
    );
  }

  return <div>{renderComponent()}</div>;
};

export default connector(SessionRouter);
